import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints } from 'src/api/APIEndpoints';
import { baseQuery } from './baseQuery';

export const binderViewerApi = createApi({
  baseQuery: baseQuery,
  reducerPath: 'binderViewerApi',
  endpoints: builder => ({
    getAllBinderViewer: builder.query<any, any>({
      query: selection => ({
        url: endPoints.isfLevel.getAll.url + selection
      }),
      keepUnusedDataFor: endPoints.isfLevel.getAll.keepUnusedDataFor
    })
  })
});

export const { useGetAllBinderViewerQuery } = binderViewerApi;
